/**
 * RISK-COUNT-FE-1 — Agent 3 contract (RISK-COUNTS-1).
 * Backend: ActiveRisksCount = number | { status: "unavailable" }
 * (shared/rollups/active-risks.ts). Never treat unavailable as 0.
 */

export const ACTIVE_RISKS_TITLE = "Active risks";
export const ACTIVE_RISKS_SUBTEXT =
  "Open + mitigated + accepted; closed excluded";

/** Matches BE ActiveRisksCountUnavailableDto. */
export type ActiveRisksCountUnavailable = { status: "unavailable" };

/** Matches BE ActiveRisksCount. */
export type ActiveRisksCount = number | ActiveRisksCountUnavailable;

export function isActiveRisksCountUnavailable(
  value: unknown,
): value is ActiveRisksCountUnavailable {
  return (
    typeof value === "object" &&
    value !== null &&
    (value as ActiveRisksCountUnavailable).status === "unavailable"
  );
}

export function isActiveRisksCountNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}
